import dayjs from '../utils/localDayjs'
import {Dayjs} from 'dayjs'

export function getWeekAndYearFromDate(date: string): {
  week: number
  year: number
} {
  const dateObj = dayjs(date)
  return {week: dateObj.week(), year: dateObj.year()}
}

/**
 * Returns the railway industry week number for a given date.
 * Convention: the week containing January 1st is always week 1 (weeks start on Monday).
 * This differs from ISO 8601 (yearStart=4) which requires ≥4 days in the new year.
 */
export function getRailwayWeek(date: Dayjs): number {
  const year = date.year()

  // Monday of the week containing Jan 1 of the current year
  const jan1 = dayjs(`${year}-01-01`)
  const week1Start = jan1.subtract(jan1.weekday() - 1, 'day')

  // Monday of the week containing Jan 1 of the next year (= start of next year's week 1)
  const nextJan1 = dayjs(`${year + 1}-01-01`)
  const nextWeek1Start = nextJan1.subtract(nextJan1.weekday() - 1, 'day')

  // Monday of the given date's week
  const currentWeekStart = date.subtract(date.weekday() - 1, 'day')

  // If this week already belongs to next year's railway week 1
  if (!currentWeekStart.isBefore(nextWeek1Start)) return 1

  return Math.round(currentWeekStart.diff(week1Start, 'day') / 7) + 1
}

export function getMondayOfWeek(week: number, year: number): string {
  return dayjs().year(year).week(week).weekday(0).format('YYYY-MM-DD')
}

export function isCurrentDay(date: string): boolean {
  const dateObj = dayjs(date)
  const today = dayjs()
  return dateObj.format('YYYY-MM-DD') === today.format('YYYY-MM-DD')
}

export function isCurrentWeek(date: string): boolean {
  const dateObj = dayjs(date)
  const today = dayjs()
  return dateObj.week() === today.week() && dateObj.year() === today.year()
}

/**
 * Expands an inclusive date range into every calendar day it spans, as sorted
 * "YYYY-MM-DD" strings. Used to feed the range picker (which works in expanded
 * day arrays) from the compact {from, to} the store keeps.
 */
export function expandInclusiveDateRange(from: string, to: string): string[] {
  const days: string[] = []
  let cur = dayjs(from)
  const last = dayjs(to)
  while (cur.isBefore(last) || cur.isSame(last, 'day')) {
    days.push(cur.format('YYYY-MM-DD'))
    cur = cur.add(1, 'day')
  }
  return days
}
